module.exports = __webpack_public_path__ + "assets/img/label2.b3dc08de.svg";